$(function () {
  // スライダーの大きさ
  const $mainImage = $('.mainImage');
  const $window = $(window);
  setmainImage($window, $mainImage);

  // スライダーの設定
  const $slider = $('.js-slider');
  $slider.on({
    init: function (event, slick, currentSlide, nextSlide) {
      slick.$slides.eq(0).addClass('zooming');
    },
    beforeChange: function (event, slick, currentSlide, nextSlide) {
      slick.$slides.eq(nextSlide).addClass('zooming');
    },
    afterChange: function (event, slick, currentSlide, nextSlide) {
      slick.$slides.eq(currentSlide - 1).removeClass('zooming');
    }
  }
  ).slick({
    autoplay: true,
    arrows: false,
    fade: true,
    pauseOnHover: false,
    speed: 1000,
    autoplaySpeed: 4000
  });

  // ブラウザリサイズでスライダーの大きさをリセット
  $window.on('resize', $.throttle(250, function () {
    setmainImage($(this), $mainImage);
  }));
});

// スライダーの大きさをセットする関数
function setmainImage ($window, $mainImage) {
  const ww = $window.width(); // ウインドウの幅
  let wh = $window.height(); // ウインドウの高さ

  // ウインドウの高さの上限を768pxに設定
  if (wh > 768) {
    wh = 768;
  }

  // ヘッダーの高さを考慮してスライダーの高さを決める
  if (ww > 1024) {
    $mainImage.css('height', wh + 'px');
  } else {
    $mainImage.css('height', (wh - 112) + 'px');
  }
}
